<div #rendererContainer class="bg-canvas"></div>
<div class="app-shell">
  <app-header></app-header>
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
